import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Header from "../components/Header";
import { useHistory } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import Button from "@material-ui/core/Button";

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: #2a2727;
  border-color: #00ffff !important;
  * {
    border-color: #00ffff !important;
  }

  &.disabled {
    label,
    input {
      color: gray !important;
    }
  }
  label,
  input {
    color: #00ffff !important;
  }
`;

const StyledBtn = styled(Button)`
  background: #00ffff !important;
  border-color: #00ffff !important;
  padding-left: 25px;
  padding-right: 25px;
  color: #000;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 50px;
`;

export default (props) => {
  let history = useHistory();



  function updateAccountSettings() {}
  return (
    <Container fixed>
      <Header>
        <Typography
          component="div"
          align="left"
          style={{ height: "100vh", marginTop: "0px" }}
        >
          <h1>Account</h1>
          <div
            style={{ display: "flex", flexDirection: "column", width: "300px" }}
          >
            <StyledTextField
              id="name"
              type="text"
              label="Name"
              variant="outlined"
            />
            <StyledTextField
              id="email"
              type="email"
              disabled
              readonly
              label="Email"
              variant="outlined"
              className="disabled"
            />
            <StyledBtn
              variant="outlined"
              color="primary"
              onClick={() => updateAccountSettings()}
            >
              Save
            </StyledBtn>
          </div>
        </Typography>
      </Header>
    </Container>
  );
};
